var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmpty)?_c('span',{staticClass:"form-date",on:{"click":_vm.toggleViewMode}},[_c('y-label',{attrs:{"element":Object.assign({}, _vm.modifiedElement, {text: _vm.valueContent})}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }